<template>
  <svg width="16" height="22" viewBox="0 0 16 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.00002 0.33374C3.93378 0.33374 0.66626 3.59998 0.66626 7.6675C0.66626 11.7337 8.00002 21.6675 8.00002 21.6675C8.00002 21.6675 15.3338 11.7337 15.3338 7.6675C15.3338 3.59998 12.0663 0.33374 8.00002 0.33374ZM8.00002 11C6.13378 11 4.66626 9.53374 4.66626 7.66622C4.66626 5.79998 6.1325 4.33246 8.00002 4.33246C9.86626 4.33246 11.3338 5.7987 11.3338 7.66622C11.3338 9.53371 9.86629 11 8.00002 11Z"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      required: true
    }
  }
}
</script>
